import styled from '@emotion/styled'
import ClipLoader from 'react-spinners/ClipLoader'

type LoadingIndicatorProps = {
  children?: JSX.Element
  isLoading: boolean
}

const LoadingOverlay = styled.div`
  height: 100%;
  width: 100%;
  background: rgba(var(--White) 0.7);
  opacity: 0.3;
  z-index: 500;
`

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 260px;
`

const StyledClipLoader = styled(ClipLoader)`
  z-index: 1000;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledIndicator = styled.div`
  z-index: 1000;
  position: absolute;
  width: 100%;
  height: 100%;
`

const StyledIndicatorInner = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

export function LoadingIndicator({ children, isLoading }: LoadingIndicatorProps) {
  if (!isLoading) return children

  return (
    <Wrapper>
      <LoadingOverlay>
        <StyledIndicator>
          <StyledIndicatorInner>
            <StyledClipLoader color="black" loading={isLoading} />
          </StyledIndicatorInner>
        </StyledIndicator>
        {children}
      </LoadingOverlay>
    </Wrapper>
  )
}
